.accordion {
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: var(--cxy-color-midnight-blue-600);
}
.accordion .headerWrapper {
  display: flex;
  justify-content: space-between;
  padding: 8px;
  border-bottom: 1px solid var(--cxy-color-midnight-blue-400);
}
@media (min-width: 1024px) {
  .accordion .headerWrapper {
    padding: 8px 16px;
  }
}
.accordion .headerWrapper .header {
  display: flex;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: left;
  padding-top: 2px;
}
.accordion .headerWrapper .icon {
  border-radius: 3px;
  height: 27px;
  width: 27px;
  min-width: 27px;
  box-sizing: border-box;
  margin-left: 8px;
  background-color: var(--cxy-color-blue-300);
}
.accordion .headerWrapper .icon.highlighted {
  background-color: var(--cxy-color-green-300);
  border: none;
}
.accordion .headerWrapper:hover {
  cursor: pointer;
}
.accordion .headerWrapper:hover .icon {
  background-color: var(--cxy-color-green-300);
}
.accordion .bodyWrapper {
  position: relative;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.4s ease-in-out;
}

.bodyWrapper.open {
  max-height: 500px;
}

.accordion .bodyWrapper .highlighter {
  width: 2px;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: var(--cxy-color-blue-300);
  z-index: var(--cxy-z-index-internal-base);
}
.accordion.faqAccordion * {
  font-size: 12px;
  line-height: 18px;
}
.accordion.faqAccordion h3 {
  line-height: 22px;
}
.accordion.faqAccordion button {
  padding: 8px !important;
}
.accordion.faqAccordion button * {
  font-size: 18px;
}
.accordion.faqAccordion p,
.accordion.faqAccordion ol,
.accordion.faqAccordion ul {
  padding: 0;
  margin-bottom: 12px;
}

.accordion.faqAccordion .headerWrapper,
.accordion.promoAccordion .headerWrapper {
  margin: 0 8px;
  padding: 0px !important;
}
.accordion.faqAccordion .headerWrapper .header,
.accordion.promoAccordion .headerWrapper .header {
  white-space: unset;
}
.accordion.faqAccordion .headerWrapper:hover,
.accordion.promoAccordion .headerWrapper:hover {
  background-color: transparent;
}
.accordion.faqAccordion .headerWrapper:hover .icon,
.accordion.promoAccordion .headerWrapper:hover .icon {
  background-color: var(--cxy-color-green-300);
}
.accordion.faqAccordion .bodyWrapper,
.accordion.promoAccordion .bodyWrapper {
  margin: 0 10px;
  margin-bottom: 2px;
  padding-bottom: 8px;
}
.accordion.promoAccordion .headerWrapper,
.accordion.promoAccordion .bodyWrapper {
  margin: 0;
  padding: 0;
}
.accordion.promoAccordion .bodyWrapper p {
  margin-bottom: 8px;
}

.accordion .accordionHeader {
  font-family: var(--cxy-font-family-sans);
  font-weight: 500;
  font-size: 1.2rem;
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0.1px;
  margin-top: 0;
  margin-bottom: 0;
  color: var(--cxy-color-white);
  text-transform: uppercase;
  display: flex;
  align-items: center;
}

.accordion .accordionHeader svg {
  font-size: 24px;
  margin-right: 4px;
}

.accordionBody {
  display: flex;
  flex-direction: column;
  background: var(--cxy-color-midnight-blue-400);
}

.accordionBody .category:hover {
  color: var(--cxy-color-green-300);
}

.accordionBody .category {
  font-family: var(--cxy-font-family-sans);
  font-weight: 500;
  font-size: 1.2rem;
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0.1px;
  margin-top: 0;
  margin-bottom: 0;
  color: var(--cxy-color-white);
  border-bottom: 1px solid var(--cxy-color-blue-700);
  padding: 8px;
}
